module.exports = __webpack_public_path__ + "img/TBWTTNL_benefits_canada.5f41ff63.png";